// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basic-container{padding:10px 6px;-webkit-box-sizing:border-box;box-sizing:border-box}.basic-container--block,.basic-container--block .el-card{height:100%}.basic-container .el-card{width:100%}.basic-container:first-child{padding-top:0}", ""]);
// Exports
module.exports = exports;
